import { copyToClipboard, date, is, Notify } from 'quasar'
import { NotifyError } from 'js/vue/boot/Notify'
import { unref } from 'vue'
import queryString from 'query-string'

const GLOBAL = {
  URLSearch: new URLSearchParams(window.location.search),

  screen: {
    md: () => window.matchMedia('(max-width: 1180px)').matches,
  },

  debounce: (time, fn, name) => {
    return (...args) => {
      clearTimeout(window[name])
      window[name] = setTimeout(() => {
        fn(...args)
      }, time)
    }
  },

  ordenateKey: (key) => (a, b) => {
    if (a[key] > b[key]) return 1
    if (a[key] < b[key]) return -1
    return 0
  },

  async copyAndAlert(text) {
    try {
      await copyToClipboard(text)
      Notify.create({
        icon: 'check_circle',
        progress: true,
        classes: 'notify-sucess',
        timeout: 2500,
        message: 'Copiado com Sucesso',
      })
    } catch (e) {
      console.log(e)
      NotifyError('Erro ao Copiar')
    }
  },

  FData(value, format = 'DD/MM/YY') {
    if (date.isValid(value)) {
      const dataFormatted =
        value.length > 10 ? value : String(value).replace('-', '/')
      const data = date.formatDate(dataFormatted, format, {
        days: [
          'Domingo',
          'Segunda',
          'Terça',
          'Quarta',
          'Quinta',
          'Sexta',
          'Sábado',
        ],
      })
      return data
    } else {
      return '-'
    }
  },

  isEmpty(obj) {
    if (!is.object(obj)) return true
    return Object.keys(obj).length === 0
  },

  compareAndReturnDiff: (oldv = {}, newv = {}) => {
    const modificado = {}
    if (!oldv || !newv) return null

    Object.entries(unref(newv)).forEach(([key, v]) => {
      const a = oldv[key]
      const b = newv[key]
      if (is.deepEqual(a, b)) return null
      else modificado[key] = v
    })
    return Object.keys(modificado)?.length ? modificado : null
  },

  generateStringFilterFromObject(obj, x) {
    const filtros = Object.entries(obj).map(
      ([key, value]) => `&${key?.trim()}=${value || ''}`
    )
    return x ? filtros.join('') : filtros.join('').replace('&', '?')
  },

  generateObjFilter() {
    const params = {}
    for (const [key, value] of new URLSearchParams(
      window.location.search
    ).entries()) {
      params[key] = value
    }
    return params
  },

  isEmptyData(data) {
    const result = {}
    if (!data) {
      result.isEmpty = true
    } else if (Array.isArray(data) && data.length === 0) {
      result.isEmpty = true
    } else if (
      typeof data === 'object' &&
      Object.keys(data).length === 0 &&
      data.constructor === Object
    ) {
      result.isEmpty = true
    } else {
      result.isEmpty = false
    }
    result.isArray = Array.isArray(data)
    result.isObject = is.object(data)

    return result
  },

  unique(value, index, self) {
    return self.indexOf(value) === index
  },
}

export default GLOBAL

export function stringifyUrl({ query = {}, url, prefix }) {
  const str = queryString.stringifyUrl(
    {
      url,
      query,
    },
    { skipEmptyString: true, skipNull: true }
  )
  return `${str}`
}

/**
 * @description Formata um número float para exibição, substituindo ponto por vírgula
 * @param {number} num - Número a ser formatado
 * @returns {number|string} - Número inteiro ou string formatada com uma casa decimal
 */
export function formatFloatNumber(num) {
  return Number.isInteger(num)
    ? num
    : Number(num).toFixed(1).replace('.', ',')
}

/**
 * @description Formata um percentual (0 a 1) para exibição com uma casa decimal
 * @param {number} value - Valor entre 0 e 1
 * @returns {string} - Percentual formatado, ex.: '28,3%'
 */
export function formatPercent(value) {
  return `${(Number(value || 0) * 100).toFixed(1).replace('.', ',')}%`
}

/**
 * @description Converte um texto em slug para nomes de arquivo/URL, ex.: 'Andina Brasil' -> 'andina-brasil'
 * @param {string} text - Texto a ser convertido
 * @returns {string} - Texto sem acentos, em minúsculas e com hífens
 */
export function slugify(text = '') {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}
